<template>
    <v-row class="total">
      <span class="label col-6">
        <div class="row" style="flex-wrap: nowrap;">
          <span class="col labeltype">
            NETO
          </span>
          <span class="col labeltype">
            DDV
          </span>
        </div>
        <v-divider color="white" />
        <div class="row justify-evenly" style="flex-wrap: nowrap;">
          <span class="col labelvalue" :style="{ 'fontSize': isMobile ? '14px' : '20px', 'color': '#000' }">
            {{ net }} €
          </span>
          <span class="col labelvalue" :style="{ 'fontSize': isMobile ? '14px' : '20px', 'color': '#000' }">
            {{ taxAmount }} €
          </span>
        </div>
      </span>
      <span class="sum col" :inner-html.prop="payment | price(2)">
      </span>
    </v-row>
  </template>

  <script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      partialList: {
        required: false,
      },
      editMode: {
        required: false,
        default: false,
        type: Boolean,
      },
      payment: {
        required: false,
        type: Number
      }
    },
    data () {
      return {
        innerPartialList: [],
      }
    },
    computed: {
      ...mapGetters(['isMobile']),
      ...mapGetters('cart', { 'cartTotal': 'itemsSum', 'partialListSum': 'givenItemsSum' }),
      /* correctCartSum () {
        // return !this.innerPartialList.length ? this.cartTotal : this.partialListSum(this.innerPartialList)
        console.log('mamama')
        return this.payment
      }, */
      net () {
        // console.log(this.innerPartialList)
        return this.innerPartialList.reduce((finalCount, curr) => {
          const floatTaxAmount = curr.taxable_amount
          const dscAmount = ((100 - (curr.discount || 0)) / 100)
          const prt = !this.editMode ? floatTaxAmount * (dscAmount) * curr.quantity : floatTaxAmount * (dscAmount)
          finalCount += prt
          return finalCount
        }, 0).toFixed(2).replace('.', ',')
      },
      taxAmount () {
        // console.log(this.innerPartialList)
        return this.innerPartialList.reduce((finalCount, curr) => {
          const floatTaxAmount = curr.tax_amount
          const dscAmount = ((100 - (curr.discount || 0)) / 100)
          const prt = !this.editMode ? floatTaxAmount * (dscAmount) * curr.quantity : floatTaxAmount * (dscAmount)
          finalCount += prt
          // console.log(finalCount)
          return finalCount
        }, 0).toFixed(2).replace('.', ',')
      },
    },
    methods: {
      correctCartSum () {
        return this.payment
      },
      setList (list) {
        this.innerPartialList = list
      },
    },
    watch: {
      partialList: {
        handler (newVal) {
          // console.log(newVal)
          this.innerPartialList = newVal
        },
        immediate: true,
      },
    },
  }
  </script>

  <style lang="scss" scoped>


  .v-divider {
    width: 80%;
    margin-left: 20px;
  }

  @media (min-width: 375px) {
    .total {
      // height: 51px !important;
      padding: 0 !important;

      span.label {
        max-width: 377px !important;
      }

      span.label .labeltype {
        font-size: 18px !important;
        padding: 0;
      }

      span.label .labelvalue {
        font-size: 14px !important;
        padding: 0;
      }
    }
  }

  .total {
    font-weight: bold;
    padding: 0 10px;
    background-color: #6FC171;
    margin-top: 0px;
    margin-bottom: 20px;
    // margin-left: 20px !important;
    border-radius: 7px;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;

    .label {
      color: white;
      display: block;
      flex-wrap: wrap;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      padding: 0px !important;
      // padding-right: 50px;
      margin: 0px !important;
      border-right: 0px solid white;
    }
    .sum {
      color: black;
      display: block;
      text-align: center;
      border-left: 1px solid #fff;
      font-size: 32px;
      padding: 0px !important;
      padding-left: 50px;
    }

  }

  .hr-breakpoint-mobile {
    .total {
      padding: 0 10px;
      margin-top: 0px;
      // display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex-wrap: wrap;

      .label {
        display: block;
        // display: flex;
        flex-wrap: wrap;
        font-size: 16px;
        border-right: 0px solid white;
        padding: 0px;
        margin: 0px;
        text-align: center;
      }
      .sum {
        display: block;
        font-size: 16px;
        padding: 0px;
        text-align: center;
        border-left: 1px solid #fff;
      }
    }
  }
  </style>